import { USER_ROLE_IN_APP } from 'models/Auth'
import {
  REPORTS,
  SHIFTS,
  TEMPLATES,
  UPSHIFTER,
  LOCATION,
  BUSINESS_UI_RELATED,
  PAYMENT,
  USERS,
  STATEMENTS,
  NOTIFICATIONS,
  APPLICANTS,
  INVOICES,
  HIDE_UNHIDE_APPLICANTS,
} from 'models/Permission'

export const permissionsPerRole = {
  [USER_ROLE_IN_APP.BUSINESS_APPROVER]: {
    // REPORTS
    [REPORTS.CREATE_REPORTS]: true,
    [REPORTS.READ_REPORTS]: true,
    [REPORTS.UPDATE_REPORTS]: true,
    [REPORTS.DELETE_REPORTS]: true,
    // SHIFTS
    [SHIFTS.READ_SHIFTS]: true,
    [SHIFTS.UPDATE_SHIFTS]: true,
    // UPSHIFTER
    [UPSHIFTER.UPDATE_UPSHIFTER]: true,
    // NOTIFICATIONS
    [NOTIFICATIONS.READ_NOTIFICATIONS]: true,
    //APPLICANTS
    [APPLICANTS.DOWNLOAD_APPLICANTS]: true,
    // HIDE/UNHIDE APPLICANTS
    [HIDE_UNHIDE_APPLICANTS.UPDATE_HIDE_UNHIDE_APPLICANTS]: true,
  },
  [USER_ROLE_IN_APP.BUSINESS_VIEWER]: {
    // SHIFTS
    [SHIFTS.READ_SHIFTS]: true,
    // NOTIFICATIONS
    [NOTIFICATIONS.READ_NOTIFICATIONS]: true,
    //APPLICANTS
    [APPLICANTS.DOWNLOAD_APPLICANTS]: true,
  },
  [USER_ROLE_IN_APP.BUSINESS_MANAGER]: {
    // REPORTS
    [REPORTS.CREATE_REPORTS]: true,
    [REPORTS.READ_REPORTS]: true,
    [REPORTS.UPDATE_REPORTS]: true,
    [REPORTS.DELETE_REPORTS]: true,
    // SHIFTS
    [SHIFTS.CREATE_SHIFTS]: true,
    [SHIFTS.READ_SHIFTS]: true,
    [SHIFTS.UPDATE_SHIFTS]: true,
    [SHIFTS.DELETE_SHIFTS]: true,
    // TEMPLATES
    [TEMPLATES.CREATE_TEMPLATES]: true,
    // UPSHIFTER
    [UPSHIFTER.UPDATE_UPSHIFTER]: true,
    // LOCATIONS
    [LOCATION.CREATE_LOCATION]: true,
    // USERS
    [USERS.UPDATE_ROLE]: true,
    // NOTIFICATIONS
    [NOTIFICATIONS.READ_NOTIFICATIONS]: true,
    // BUSINESS_UI_RELATED
    [BUSINESS_UI_RELATED.CAN_UPDATE_SITE_MANAGERS]: true,
    //APPLICANTS
    [APPLICANTS.DOWNLOAD_APPLICANTS]: true,
    // INVOICES
    [INVOICES.READ_INVOICE]: true,
    [INVOICES.PAY_INVOICE]: false,
    // HIDE/UNHIDE APPLICANTS
    [HIDE_UNHIDE_APPLICANTS.UPDATE_HIDE_UNHIDE_APPLICANTS]: true,
  },
  [USER_ROLE_IN_APP.BUSINESS_SITE_MANAGER]: {
    // REPORTS
    [REPORTS.CREATE_REPORTS]: true,
    [REPORTS.READ_REPORTS]: true,
    [REPORTS.UPDATE_REPORTS]: true,
    [REPORTS.DELETE_REPORTS]: true,
    // SHIFTS
    [SHIFTS.CREATE_SHIFTS]: true,
    [SHIFTS.READ_SHIFTS]: true,
    [SHIFTS.UPDATE_SHIFTS]: true,
    [SHIFTS.DELETE_SHIFTS]: true,
    // TEMPLATES
    [TEMPLATES.CREATE_TEMPLATES]: true,
    // LOCATIONS
    [LOCATION.CREATE_LOCATION]: true,
    // UPSHIFTER
    [UPSHIFTER.UPDATE_UPSHIFTER]: true,
    // NOTIFICATIONS
    [NOTIFICATIONS.READ_NOTIFICATIONS]: true,
    // USERS
    [USERS.UPDATE_ROLE]: true,
    //APPLICANTS
    [APPLICANTS.DOWNLOAD_APPLICANTS]: true,
    // INVOICES
    [INVOICES.READ_INVOICE]: true,
    [INVOICES.PAY_INVOICE]: false,
    // HIDE/UNHIDE APPLICANTS
    [HIDE_UNHIDE_APPLICANTS.UPDATE_HIDE_UNHIDE_APPLICANTS]: true,
  },
  [USER_ROLE_IN_APP.BUSINESS_ADMIN]: {
    // REPORTS
    [REPORTS.CREATE_REPORTS]: true,
    [REPORTS.READ_REPORTS]: true,
    [REPORTS.UPDATE_REPORTS]: true,
    [REPORTS.DELETE_REPORTS]: true,
    // STATEMENTS
    [STATEMENTS.READ_STATEMENTS]: true,
    // SHIFTS
    [SHIFTS.CREATE_SHIFTS]: true,
    [SHIFTS.READ_SHIFTS]: true,
    [SHIFTS.UPDATE_SHIFTS]: true,
    [SHIFTS.DELETE_SHIFTS]: true,
    // Payment
    [PAYMENT.READ_PAYMENT]: true,
    //Location
    [LOCATION.CREATE_LOCATION]: true,
    // TEMPLATES
    [TEMPLATES.CREATE_TEMPLATES]: true,
    // USERS
    [USERS.UPDATE_ROLE]: true,
    // UPSHIFTER
    [UPSHIFTER.UPDATE_UPSHIFTER]: true,
    // NOTIFICATIONS
    [NOTIFICATIONS.READ_NOTIFICATIONS]: true,
    // BUSINESS_UI_RELATED
    [BUSINESS_UI_RELATED.CAN_READ_COMPANY_NAME]: true,
    [BUSINESS_UI_RELATED.CAN_UPDATE_SITE_MANAGERS]: true,
    [BUSINESS_UI_RELATED.CAN_UPDATE_MANAGERS]: true,
    //APPLICANTS
    [APPLICANTS.DOWNLOAD_APPLICANTS]: true,
    // INVOICES
    [INVOICES.READ_INVOICE]: true,
    [INVOICES.PAY_INVOICE]: true,
    // HIDE/UNHIDE APPLICANTS
    [HIDE_UNHIDE_APPLICANTS.UPDATE_HIDE_UNHIDE_APPLICANTS]: true,
  },
  [USER_ROLE_IN_APP.BUSINESS_FINANCE_MANAGER]: {
    // INVOICES
    [INVOICES.READ_INVOICE]: true,
    [INVOICES.PAY_INVOICE]: true,
    // HIDE/UNHIDE APPLICANTS
    [HIDE_UNHIDE_APPLICANTS.UPDATE_HIDE_UNHIDE_APPLICANTS]: true,
  },
  [USER_ROLE_IN_APP.UPSHIFTER]: {
    [NOTIFICATIONS.READ_NOTIFICATIONS]: true,
  },
}
